import {
  SET_CONNECTION,
  RESET_CONNECTION,
  SET_UNIT_NO,
  SET_BUILDING_NO,
  SET_STATUS,
  SET_AUTOFOCUS
} from "../actions/connection";

const initialState = {
  address: "",
  unitNo: "",
  bid: null,
  city: null,
  province: null,
  result_type: null,
  status: null,
  placeId: null,
  fromPage: null,
  autofocus: false,
  security_concierge: null
};

const connection = (state = initialState, action) => {
  switch (action.type) {
    case SET_CONNECTION:
      return { ...state, ...action.payload };
    case SET_UNIT_NO:
      return { ...state, unitNo: action.payload };
    case RESET_CONNECTION:
      return initialState;
    case SET_BUILDING_NO:
      return { ...state, bid: action.payload };
    case SET_STATUS:
      return { ...state, status: action.payload };
    case SET_AUTOFOCUS:
      return { ...state, autofocus: action.payload };
    default:
      return state;
  }
};

export default connection;



// WEBPACK FOOTER //
// ./src/store/reducers/connection.js